import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

function LiveVenue({ scrollYProgress, location, startTime, endTime, weddingDate, fontP, streetAddress, city, state, postcode }) {
   const ref = useRef(null);
   const isInView = useInView(ref, { margin: '-20% 0px -20% 0px' });

  function convertTo12HourFormat(time24) {
    const [hours, minutes] = time24.split(":");
    const period = hours >= 12 ? "pm" : "am";
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
  
    return `${hours12}:${minutes} ${period}`;
  }

  const startTimeNew = convertTo12HourFormat(startTime);
  const endTimeNew = convertTo12HourFormat(endTime);

  const weddingDateSet = new Date(weddingDate);
  const weddingDay = getDayFromDate(weddingDateSet);

  const formattedDate = weddingDateSet.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  // Function to calculate the day from a given date
  function getDayFromDate(date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayIndex = date.getDay();
    localStorage.setItem('Day', days[dayIndex]);
    return days[dayIndex];
  }
  return (
    <motion.div 
      ref={ref}
      initial={{ opacity: 0, y: -50 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 1.5, ease: 'easeInOut' }}
      className="text-center pt-10 pb-20 md:w-3/5 w-4/5 mx-auto"
    >
      <h1 className={`text-l mt-8 mb-4 uppercase font-bold ${fontP}`}>Location</h1>
      {location && <span className="block">{location}</span>}
      {streetAddress && <span className="block">{streetAddress}</span>}
      {postcode && city && <span className="block">{postcode}, {city}</span>}
      {state && <span className="block">{state}</span>}

      <h1 className={`text-l mt-8 mb-4 uppercase font-bold ${fontP}`}>Date</h1>
      <p className={`text-l ${fontP}`}>{weddingDay}, {formattedDate}</p>

      <h1 className={`text-l mt-8 mb-4 uppercase font-bold ${fontP}`}>Time</h1>
      <p className={`text-l ${fontP}`}>{startTimeNew} - {endTimeNew}</p>
    </motion.div>
  );
}

export default LiveVenue;
